import type { ActivityLog } from "@/types";

const DOT: Record<string, string> = {
  primary: "bg-primary-500",
  accent: "bg-accent-500",
  secondary: "bg-secondary-500",
};

function formatRelative(iso: string) {
  const time = new Date(iso).getTime();
  if (Number.isNaN(time)) return iso;
  const minutes = Math.floor((Date.now() - time) / 60000);
  if (minutes < 1) return "刚刚";
  if (minutes < 60) return `${minutes} 分钟前`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} 小时前`;
  const days = Math.floor(hours / 24);
  if (days === 1) return "昨天";
  if (days < 30) return `${days} 天前`;
  return iso.slice(0, 10);
}

export default function ActivityFeed({ items }: { items: ActivityLog[] }) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-5">
      <div className="mb-4">
        <h3 className="font-heading text-base font-semibold text-foreground-950">最近活动</h3>
        <p className="mt-1 text-xs text-foreground-500">跳转规则的最新变更记录</p>
      </div>
      {items.length === 0 ? (
        <p className="text-sm text-foreground-500">还没有操作记录。新增、导入或修改域名后会显示在这里。</p>
      ) : (
        <div className="flex flex-col">
          {items.map((item, index) => (
            <div key={item.id} className="flex gap-3">
              <div className="flex flex-col items-center">
                <span className={`mt-1.5 h-2.5 w-2.5 rounded-full ${DOT[item.tone]}`} />
                {index !== items.length - 1 ? <span className="my-1 w-px flex-1 bg-background-200" /> : null}
              </div>
              <div className="pb-4">
                <p className="text-sm text-foreground-900">
                  <span className="font-medium">{item.domain}</span>
                </p>
                <p className="mt-0.5 text-xs text-foreground-600">{item.action}</p>
                <p className="mt-1 text-xs text-foreground-400">{formatRelative(item.at)}</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}